import React from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  foldableSection: {
    color: colors.black87,
    textTransform: "uppercase",
    fontWeight: 500,
    marginBottom: "8px",
  },
  clickableArea: {
    cursor: "pointer",
    zIndex: 200,
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const FoldableSection = (props) => {
  const { classes, title, defaultOpen = true } = props;
  const [open, setOpen] = React.useState(defaultOpen);

  return (
    <>
      <Grid
        container
        wrap="nowrap"
        className={clsx(classes.foldableSection, props.className)}
        style={props.style}
      >
        <Grid
          item
          className={classes.clickableArea}
          onClick={() => setOpen(!open)}
          style={{ width: "20px" }}
        >
          <img
            src={open ? images.arrowOpenBlack : images.arrowClosedBlack}
            alt="arrow"
          />
        </Grid>
        <Grid
          item
          className={classes.clickableArea}
          onClick={() => setOpen(!open)}
        >
          {title}
        </Grid>
      </Grid>
      {open && props.children}
    </>
  );
};

FoldableSection.propTypes = {
  title: PropTypes.string.isRequired,
  defaultOpen: PropTypes.bool,
};

export default withStyles(styles)(FoldableSection);
